<template>
  <input
    :type="inputType"
    :placeholder="formattedPlaceholder"
    :value="formattedValue"
    :disabled="disabled"
    class="currency-input rounded-md border-solid border border-EXPONDO-grey-20 px-1 py-0.5
      placeholder:text-EXPONDO-grey-60"
    inputmode="numeric"
    @input="onInput($event.target.value)"
    @focus="onFocus"
    @blur="onBlur"
  >
</template>

<script lang="ts">


export default defineComponent({
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number as PropType<Nullable<number>>,
      default: null,
    },
    placeholder: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {

    const { formatCurrency } = useFormatCurrency();

    const inputValue = ref<Nullable<number>>(props.value);
    const focused = ref(false);

    watch(() => props.value, (newValue) => {

      inputValue.value = newValue;

    });

    const emitInput = (value: Nullable<number>) => {

      emit('input', value);

    };

    const formattedPlaceholder = computed(() =>
      props.placeholder !== null ? formatCurrency(props.placeholder) : '');

    const formattedValue = computed(() => {

      if (focused.value) {

        return inputValue.value;

      }

      return inputValue.value !== null ? formatCurrency(inputValue.value) : '';

    });

    const inputType = computed(() => focused.value ? 'number' : 'text');

    function onInput(value: string): void {

      const numericValue = parseInt(value) || null;
      inputValue.value = numericValue;
      emitInput(numericValue);

    }

    function onFocus() {

      focused.value = true;

    }

    function onBlur() {

      focused.value = false;

    }

    return {
      inputValue,
      inputType,
      emitInput,
      onInput,
      onFocus,
      onBlur,
      formattedValue,
      formattedPlaceholder,
    };

  },
});

</script>

<style lang="scss" scoped>
.currency-input {
  /* Firefox */
  appearance: textfield;

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
